import Vue from "vue";
import axios from "axios";
import Vuex from "vuex";
import { getField, updateField } from "vuex-map-fields";
import common from "./modules/common";
import auth from "./modules/auth";
import site from "./modules/site";
import users from "./modules/Users/users";
import roles from "./modules/Users/roles";
import rights from "./modules/Users/rights";
import am_search from "./modules/AM/am_search";
import am_aliases from "./modules/AM/am_aliases";
import am_crosses from "./modules/AM/am_crosses";
import suppliers from "./modules/Suppliers/suppliers";
import pricelists from "./modules/Suppliers/pricelists";
import data_import from "./modules/Dataimport/data_import";
import customers from "./modules/Customers/customers";
import customer_types from "./modules/Customers/customer_types";
import customer_sources from "./modules/Customers/customer_sources";
import customer_messages from "./modules/Customers/customer_messages";
import statuses from "./modules/Statuses/statuses";
import orders from "./modules/Orders/orders";
import cart from "./modules/Cart/cart";
import prices_types from "./modules/Prices/prices_types";
import garage from "./modules/Garage/garage";
import payments from "./modules/Payments/payments";
import costs from "./modules/Costs/costs";
import repairtimes from "./modules/Repairtimes/repairtimes";
import posts from "./modules/Posts/posts";
import intervals from "./modules/Intervals/intervals";
import storages from "./modules/Storages/storages"; //склады
import goods from "./modules/Storages/goods"; //товары
import nomenclatures from "./modules/Storages/nomenclatures"; //номенклатура
import unit_of_measurements from "./modules/Storages/unit_of_measurements"; //единицы измерения
import goods_movement_document_types from "./modules/Storages/goods_movement_document_types"; //Тип документа для движения на складе
import goods_remains from "./modules/Storages/goods_remains"; //Остатки на складе
import goods_reserves from "./modules/Storages/goods_reserves"; //Товар зарезервированный на складе
import goods_export_urls from "./modules/Storages/goods_export_urls";
import goods_movement_bases from "./modules/Storages/goods_movement_bases";
import pricemarkups from "./modules/Pricemarkups/pricemarkups"; //товары
import analytics from "./modules/Analytics/analytics"; //аналитика
import targets from "./modules/Analytics/targets"; //цели для аналитик
import shops from "./modules/Shops/shops"; //shops
import shop_payment_details from "./modules/Shops/shop_payment_details"; //банковские реквизиты
import diagnostics from "./modules/Diagnostics/diagnostics"; //diagnostics
import tables_config from "./modules/TablesConfig/tables_config"; //настройки таблиц
import sms_templates from "./modules/SMSTemplates/sms_templates"; //шаблоны SMS
import sms_templates_placeholders from "./modules/SMSTemplates/sms_templates_placeholders"; //placeholders для шаблонов SMS
import navigation_menu from "./modules/NavigationMenu/navigation_menu"
import receipts from "./modules/Receipts/receipts";
import receipts_settings from "./modules/Receipts/receipts_settings";
import order_inspection_reports from "./modules/Orders/order_inspection_reports";
import order_stages from "./modules/Orders/order_stages";
import telephonies from "./modules/Telephonies/telephonies";
import sms_gateways from "./modules/Sms_gateways/sms_gateways";
import calls from "./modules/Calls/calls";
import bids from "./modules/Bids/bids";
import bid_stages from "./modules/Bids/bid_stages";
import tarrifplans from "./modules/Tarrifplans/tarrifplans";
import helptour from "./modules/Helptour/helptour";
import applicability from "./modules/Applicability/applicability";
import ozon_seller_api from "./modules/Storages/ozon_seller_api";
import main_widget_parameters from "./modules/MainWidgetParameters/main_widget_parameters.js";
Vue.use(Vuex);
axios.defaults.withCredentials = true;
export default new Vuex.Store({
  modules: {
    shop_payment_details,
    common,
    receipts,
    receipts_settings,
    auth,
    site,
    users,
    roles,
    rights,
    am_search,
    am_aliases,
    am_crosses,
    suppliers,
    pricelists,
    customers,
    customer_types,
    customer_messages,
    diagnostics,
    data_import,
    customer_sources,
    prices_types,
    statuses,
    order_stages,
    orders,
    cart,
    garage,
    payments,
    costs,
    repairtimes,
    posts,
    intervals,
    storages,
    goods,
    goods_movement_document_types,
    goods_export_urls,
    goods_movement_bases,
    goods_remains,
    goods_reserves,
    order_inspection_reports,
    pricemarkups,
    analytics,
    targets,
    shops,
    telephonies,
    sms_gateways,
    calls,
    bids,
    bid_stages,
    tarrifplans,
    helptour,
    applicability,
    nomenclatures,
    unit_of_measurements,
    ozon_seller_api,
    sms_templates,
    sms_templates_placeholders,
    tables_config,
    navigation_menu,
    main_widget_parameters
  },
});
